export function handleFormChange(setFormData) {
    return (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }))
    }
}
